import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-login',
    imports: [ReactiveFormsModule,MatCardModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: true
})
export class LoginComponent {
  loginForm: FormGroup;

  constructor(private fb: FormBuilder, private router: Router) {
    this.loginForm = this.fb.group({
      username: [''],
      password: ['']
    });
  }

  onLogin(): void {
    if (this.loginForm.valid) {
      // Here, you can add logic to verify credentials if needed
      // alert('Login Successful');
      this.router.navigate(['/landing-page']);
    } else {
      alert('Please fill out the form correctly.');
    }
  }

  onSSO(): void {
    alert('SSO button clicked');
  }
}
